import React, { useState } from 'react';
import * as S from './styles';
import LogoIcon from '../../imgs/ico.png';
import { 
  FaBuilding, 
  FaCrosshairs, 
  FaLightbulb, 
  FaCogs, 
  FaGift, 
  FaCalendarCheck, 
  FaArrowRight, 
  FaFileContract, 
  FaCar, 
  FaClock,
  FaRegCalendarAlt, 
  FaRegUser 
} from 'react-icons/fa';

export default function AutomacaoAutomec() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (email === 'antunes.nascimento@grupoautomec.com.br' && password === '$automec2026') {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Credenciais inválidas. Tente novamente.');
    }
  };

  if (!isAuthenticated) {
    return (
      <S.LoginContainer>
        <S.LoginCard>
          <S.LoginHeader>
            <S.Logo>
              <img src={LogoIcon} alt="Vidal" style={{ width: 48, height: 48 }} />
            </S.Logo>
            <S.LoginTitle>Acesso Restrito</S.LoginTitle>
            <S.LoginSubtitle>
              Digite suas credenciais para visualizar esta proposta
            </S.LoginSubtitle>
          </S.LoginHeader>

          <S.LoginForm onSubmit={handleLogin}>
            <S.InputGroup>
              <S.Label>Email Corporativo</S.Label>
              <S.Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu.nome@grupoautomec.com.br"
                required
              />
            </S.InputGroup>

            <S.InputGroup>
              <S.Label>Senha de Acesso</S.Label>
              <S.Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </S.InputGroup>

            {error && <S.ErrorMessage>{error}</S.ErrorMessage>}

            <S.LoginButton type="submit">
              Entrar
            </S.LoginButton>
          </S.LoginForm>
        </S.LoginCard>
      </S.LoginContainer>
    );
  }

  return (
    <S.PageWrapper>
      <S.GlobalStyle />
      
      {/* Navbar */}
      <S.Navbar>
        <S.NavbarContainer>
          <S.NavbarBrand href="#capa">
            <img
              src="https://i.ibb.co/RkZvggsr/logo.png"
              alt="VIDAL Automação Inteligente"
            />
          </S.NavbarBrand>

          <S.NavbarToggle $active={mobileMenuOpen} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </S.NavbarToggle>

          <S.NavbarNav $active={mobileMenuOpen}>
            <li>
              <S.NavLink href="#sobre">
                <FaBuilding /> Sobre a VIDAL
              </S.NavLink>
            </li>
            <li>
              <S.NavLink href="#desafios">
                <FaCrosshairs /> Desafios
              </S.NavLink>
            </li>
            <li>
              <S.NavLink href="#solucoes">
                <FaLightbulb /> Soluções
              </S.NavLink>
            </li>
            <li>
              <S.NavLink href="#metodologia">
                <FaCogs /> Metodologia
              </S.NavLink>
            </li>
            <li>
              <S.NavLink href="#beneficios">
                <FaGift /> Benefícios
              </S.NavLink>
            </li>
            <li>
              <S.NavCta href="https://wa.me/5515981198493" target="_blank">
                <FaCalendarCheck /> Agendar Reunião
              </S.NavCta>
            </li>
          </S.NavbarNav>
          
          <S.NavbarOverlay $active={mobileMenuOpen} onClick={() => setMobileMenuOpen(false)} />
        </S.NavbarContainer>
      </S.Navbar>

      {/* Hero Section */}
      <S.HeroSection id="capa">
        <S.Container>
          <S.HeroContent>
            <S.HeroBadge>
              <span className="pulse"></span>
              PROPOSTA DE AUTOMAÇÃO
            </S.HeroBadge>
            
            <S.HeroTitle>
              Transformação Digital através de <span className="highlight">Automação Inteligente</span>
            </S.HeroTitle>
            
            <S.HeroSubtitle>
              Soluções personalizadas de automação e integração de sistemas para 
              otimizar operações e impulsionar resultados na Automec
            </S.HeroSubtitle>
            
            <S.HeroButtons>
              <S.Button href="#solucoes" $primary>
                Conhecer Soluções <FaArrowRight />
              </S.Button>
              <S.Button href="#sobre" $outline>
                Sobre a VIDAL
              </S.Button>
            </S.HeroButtons>

            {/* Proposal Data Card */}
            <S.ProposalData>
              <S.ProposalDataHeader />
              <S.ProposalDataContent>
                <S.ProposalDataTitle>
                  <FaFileContract /> Dados da Proposta
                </S.ProposalDataTitle>
                
                <S.ProposalDataGrid>
                  <S.DataItem>
                    <S.DataLabel>Preparado para</S.DataLabel>
                    <S.DataValue>
                      <FaBuilding /> Automec - Concessionária de Veículos
                    </S.DataValue>
                  </S.DataItem>
                  
                  <S.DataItem>
                    <S.DataLabel>Setor</S.DataLabel>
                    <S.DataValue>
                      <FaCar /> Automotivo - Vendas e Serviços
                    </S.DataValue>
                  </S.DataItem>
                  
                  <S.DataItem>
                    <S.DataLabel>Data de Emissão</S.DataLabel>
                    <S.DataValue>
                      <FaRegCalendarAlt /> <span>05 de janeiro de 2026</span>
                    </S.DataValue>
                  </S.DataItem>

                  <S.DataItem>
                    <S.DataLabel>Validade</S.DataLabel>
                    <S.DataValue>
                      <FaClock /> 60 dias
                    </S.DataValue>
                  </S.DataItem>

                  <S.DataItem>
                    <S.DataLabel>Responsável</S.DataLabel>
                    <S.DataValue>
                      <FaRegUser /> <span>Equipe VIDAL - Automação e Desenvolvimento</span>
                    </S.DataValue>
                  </S.DataItem>
                </S.ProposalDataGrid>
              </S.ProposalDataContent>
            </S.ProposalData>

          </S.HeroContent>
        </S.Container>
      </S.HeroSection>

      {/* Section 1: Sobre a VIDAL */}
      <S.Section id="sobre" className="section-1">
        <S.Container>
          <S.SectionHeader>
            <S.SectionBadge>
              <S.FaRocketIcon />
              SEÇÃO 1
            </S.SectionBadge>

            <S.SectionTitle>
              <FaBuilding />
              Quem é a VIDAL
            </S.SectionTitle>

            <S.SectionSubtitle>
              Inovação e tecnologia aplicadas à transformação digital de negócios
            </S.SectionSubtitle>
          </S.SectionHeader>

          {/* Introdução da Empresa */}
          <S.ContentCard>
            <p>
              A VIDAL é uma empresa de tecnologia especializada em{' '}
              <strong>automação inteligente</strong>,{' '}
              <strong>desenvolvimento de software personalizado</strong> e{' '}
              <strong>integração de sistemas</strong>. Combinamos expertise
              técnica com profundo conhecimento de negócios para criar soluções
              que geram resultados reais e mensuráveis.
            </p>
          </S.ContentCard>

          {/* Nossos Pilares */}
          <S.PillarsGrid>
            {/* Pilar 1: Automação Inteligente */}
            <S.PillarCard className="purple">
              <S.PillarIcon className="purple">
                <S.FaRobotIcon />
              </S.PillarIcon>
              <S.PillarTitle>Automação Inteligente</S.PillarTitle>
              <S.PillarDescription>
                RPA, IA e Machine Learning para automatizar processos complexos e
                repetitivos
              </S.PillarDescription>
              <S.PillarList>
                <li>Redução de até 90% em tempo de processos manuais</li>
                <li>Integração com sistemas legados e modernos</li>
                <li>Automação com inteligência artificial</li>
              </S.PillarList>
            </S.PillarCard>

            {/* Pilar 2: Desenvolvimento de Software */}
            <S.PillarCard className="blue">
              <S.PillarIcon className="blue">
                <S.FaCodeIcon />
              </S.PillarIcon>
              <S.PillarTitle>Desenvolvimento de Software</S.PillarTitle>
              <S.PillarDescription>
                Soluções sob medida com tecnologias modernas e arquitetura
                escalável
              </S.PillarDescription>
              <S.PillarList>
                <li>APIs RESTful e microsserviços</li>
                <li>Aplicações web e mobile</li>
                <li>Integração de sistemas (ERP, CRM, e-commerce)</li>
              </S.PillarList>
            </S.PillarCard>

            {/* Pilar 3: Inteligência Artificial */}
            <S.PillarCard className="green">
              <S.PillarIcon className="green">
                <S.FaBrainIcon />
              </S.PillarIcon>
              <S.PillarTitle>Inteligência Artificial</S.PillarTitle>
              <S.PillarDescription>
                IA aplicada para análise de dados, predição e tomada de decisão
                automatizada
              </S.PillarDescription>
              <S.PillarList>
                <li>Processamento de linguagem natural (NLP)</li>
                <li>Visão computacional</li>
                <li>Análise preditiva e otimização</li>
              </S.PillarList>
            </S.PillarCard>
          </S.PillarsGrid>

          {/* Diferenciais VIDAL */}
          <S.DifferentialsBox>
            <S.DifferentialsHeader>
              <S.FaStarIcon />
              <h3>Por que escolher a VIDAL?</h3>
            </S.DifferentialsHeader>

            <S.DifferentialsGrid>
              <S.DifferentialItem>
                <S.FaCheckCircleIcon />
                <div className="differential-content">
                  <strong>Expertise Técnica</strong>
                  <p>Equipe especializada em tecnologias de ponta</p>
                </div>
              </S.DifferentialItem>

              <S.DifferentialItem>
                <S.FaCheckCircleIcon />
                <div className="differential-content">
                  <strong>Abordagem Consultiva</strong>
                  <p>Entendemos seu negócio antes de propor soluções</p>
                </div>
              </S.DifferentialItem>

              <S.DifferentialItem>
                <S.FaCheckCircleIcon />
                <div className="differential-content">
                  <strong>Soluções Personalizadas</strong>
                  <p>Cada projeto é único e feito sob medida</p>
                </div>
              </S.DifferentialItem>

              <S.DifferentialItem>
                <S.FaCheckCircleIcon />
                <div className="differential-content">
                  <strong>Suporte Contínuo</strong>
                  <p>Acompanhamento pós-implementação e evolução constante</p>
                </div>
              </S.DifferentialItem>
            </S.DifferentialsGrid>
          </S.DifferentialsBox>
        </S.Container>
      </S.Section>

      {/* Section 2: Desafios Identificados */}
      <S.Section id="desafios" className="section-2">
        <S.Container>
          <S.SectionHeader>
            <S.SectionBadge>
              <FaCrosshairs />
              SEÇÃO 2
            </S.SectionBadge>

            <S.SectionTitle>
              <FaCrosshairs />
              Oportunidades de Automação na Automec
            </S.SectionTitle>

            <S.SectionSubtitle>
              Identificamos processos manuais que podem ser otimizados através de
              automação inteligente
            </S.SectionSubtitle>
          </S.SectionHeader>

          {/* Introdução */}
          <S.ContentCard>
            <p>
              Durante nossa análise inicial, identificamos{' '}
              <strong>duas oportunidades estratégicas de automação</strong> que
              podem gerar ganhos significativos em eficiência operacional, redução
              de erros e agilidade no atendimento.
            </p>
          </S.ContentCard>

          {/* Desafio 1: Auto Checkout */}
          <S.ChallengeContainer>
            {/* Card de Introdução do Desafio */}
            <S.ChallengeIntroCard>
              <S.ChallengeIntroHeader>
                <S.ChallengeNumber>01</S.ChallengeNumber>
                <S.ChallengeIntroContent>
                  <h3>
                    <S.FaShoppingCartIcon />
                    Integração do Token de Auto Checkout
                  </h3>
                  <p>
                    Sistema de auto checkout implementado sem integração com o ERP,
                    gerando processos manuais e riscos operacionais
                  </p>
                </S.ChallengeIntroContent>
              </S.ChallengeIntroHeader>
            </S.ChallengeIntroCard>

            {/* Grid de Detalhes */}
            <S.ChallengeDetailsGrid>
              {/* Card: Situação Atual */}
              <S.ChallengeDetailCard className="blue">
                <S.ChallengeDetailHeader>
                  <div className="challenge-detail-icon">
                    <S.FaExclamationCircleIcon />
                  </div>
                  <h4 className="challenge-detail-title">Situação Atual</h4>
                </S.ChallengeDetailHeader>
                <S.ChallengeDetailList>
                  <li>Token de auto checkout operando isoladamente</li>
                  <li>Sem integração com sistema de gestão</li>
                  <li>Conciliação manual de transações</li>
                  <li>Dados fragmentados entre sistemas</li>
                </S.ChallengeDetailList>
              </S.ChallengeDetailCard>

              {/* Card: Pontos de Dor */}
              <S.ChallengeDetailCard className="orange">
                <S.ChallengeDetailHeader>
                  <div className="challenge-detail-icon">
                    <S.FaTimesCircleIcon />
                  </div>
                  <h4 className="challenge-detail-title">Pontos de Dor</h4>
                </S.ChallengeDetailHeader>
                <S.ChallengeDetailList>
                  <li>Retrabalho manual diário da equipe</li>
                  <li>Alto risco de inconsistências</li>
                  <li>Atrasos na atualização de estoque</li>
                  <li>Tempo desperdiçado em tarefas repetitivas</li>
                </S.ChallengeDetailList>
              </S.ChallengeDetailCard>

              {/* Card: Impacto Operacional */}
              <S.ChallengeDetailCard className="purple">
                <S.ChallengeDetailHeader>
                  <div className="challenge-detail-icon">
                    <S.FaChartLineIcon />
                  </div>
                  <h4 className="challenge-detail-title">Impacto Operacional</h4>
                </S.ChallengeDetailHeader>
                <S.ChallengeDetailList>
                  <li>Experiência do cliente comprometida</li>
                  <li>Sobrecarga da equipe administrativa</li>
                  <li>Impossibilidade de escalar operação</li>
                  <li>Perda de visibilidade em tempo real</li>
                </S.ChallengeDetailList>
              </S.ChallengeDetailCard>

              {/* Card: Riscos */}
              <S.ChallengeDetailCard className="cyan">
                <S.ChallengeDetailHeader>
                  <div className="challenge-detail-icon">
                    <S.FaShieldAltIcon />
                  </div>
                  <h4 className="challenge-detail-title">Riscos Identificados</h4>
                </S.ChallengeDetailHeader>
                <S.ChallengeDetailList>
                  <li>Erros de conciliação financeira</li>
                  <li>Divergências de estoque</li>
                  <li>Compliance comprometido</li>
                  <li>Dados não confiáveis para decisões</li>
                </S.ChallengeDetailList>
              </S.ChallengeDetailCard>
            </S.ChallengeDetailsGrid>

            {/* Métricas de Impacto */}
            <S.ImpactMetrics>
              <S.ImpactMetric>
                <div className="impact-metric-icon">
                  <S.FaClockIcon />
                </div>
                <div className="impact-metric-label">Tempo Perdido</div>
                <div className="impact-metric-value">
                  Horas diárias em processos manuais
                </div>
              </S.ImpactMetric>

              <S.ImpactMetric>
                <div className="impact-metric-icon">
                  <S.FaExclamationTriangleIcon />
                </div>
                <div className="impact-metric-label">Erros</div>
                <div className="impact-metric-value">
                  Alto risco de inconsistências
                </div>
              </S.ImpactMetric>

              <S.ImpactMetric>
                <div className="impact-metric-icon">
                  <S.FaChartLineDownIcon />
                </div>
                <div className="impact-metric-label">Eficiência</div>
                <div className="impact-metric-value">
                  Operação limitada e não escalável
                </div>
              </S.ImpactMetric>
            </S.ImpactMetrics>
          </S.ChallengeContainer>

          {/* Desafio 2: Seguradoras */}
          <S.ChallengeContainer>
            {/* Card de Introdução do Desafio */}
            <S.ChallengeIntroCard>
              <S.ChallengeIntroHeader>
                <S.ChallengeNumber>02</S.ChallengeNumber>
                <S.ChallengeIntroContent>
                  <h3>
                    <S.FaShieldAltIcon />
                    Automação de Aplicação para Seguradoras
                  </h3>
                  <p>
                    Processo manual de consulta e aplicação para entrega de peças e
                    veículos às seguradoras, resultando em lentidão e perda de
                    oportunidades
                  </p>
                </S.ChallengeIntroContent>
              </S.ChallengeIntroHeader>
            </S.ChallengeIntroCard>

            {/* Grid de Detalhes */}
            <S.ChallengeDetailsGrid>
              {/* Card: Situação Atual */}
              <S.ChallengeDetailCard className="cyan">
                <S.ChallengeDetailHeader>
                  <div className="challenge-detail-icon">
                    <S.FaExclamationCircleIcon />
                  </div>
                  <h4 className="challenge-detail-title">Situação Atual</h4>
                </S.ChallengeDetailHeader>
                <S.ChallengeDetailList>
                  <li>Seguradoras publicam demandas em sistema próprio</li>
                  <li>Consulta manual de disponibilidade no ERP</li>
                  <li>Aplicação manual para cada oportunidade</li>
                  <li>Processo lento e propenso a erros</li>
                </S.ChallengeDetailList>
              </S.ChallengeDetailCard>

              {/* Card: Pontos de Dor */}
              <S.ChallengeDetailCard className="purple">
                <S.ChallengeDetailHeader>
                  <div className="challenge-detail-icon">
                    <S.FaTimesCircleIcon />
                  </div>
                  <h4 className="challenge-detail-title">Pontos de Dor</h4>
                </S.ChallengeDetailHeader>
                <S.ChallengeDetailList>
                  <li>Tempo de resposta elevado (horas/dias)</li>
                  <li>Sobrecarga da equipe comercial</li>
                  <li>Oportunidades perdidas por lentidão</li>
                  <li>Falta de competitividade no mercado</li>
                </S.ChallengeDetailList>
              </S.ChallengeDetailCard>

              {/* Card: Impacto Operacional */}
              <S.ChallengeDetailCard className="blue">
                <S.ChallengeDetailHeader>
                  <div className="challenge-detail-icon">
                    <S.FaChartLineIcon />
                  </div>
                  <h4 className="challenge-detail-title">Impacto Operacional</h4>
                </S.ChallengeDetailHeader>
                <S.ChallengeDetailList>
                  <li>Equipe focada em tarefas operacionais</li>
                  <li>Impossibilidade de monitorar 24/7</li>
                  <li>Dados desatualizados entre sistemas</li>
                  <li>Dificuldade em escalar operação</li>
                </S.ChallengeDetailList>
              </S.ChallengeDetailCard>

              {/* Card: Riscos */}
              <S.ChallengeDetailCard className="orange">
                <S.ChallengeDetailHeader>
                  <div className="challenge-detail-icon">
                    <S.FaShieldAltIcon />
                  </div>
                  <h4 className="challenge-detail-title">Riscos Identificados</h4>
                </S.ChallengeDetailHeader>
                <S.ChallengeDetailList>
                  <li>Perda de receita por oportunidades não capturadas</li>
                  <li>Relacionamento com seguradoras comprometido</li>
                  <li>Concorrentes mais ágeis ganham mercado</li>
                  <li>Crescimento limitado pela capacidade manual</li>
                </S.ChallengeDetailList>
              </S.ChallengeDetailCard>
            </S.ChallengeDetailsGrid>

            {/* Métricas de Impacto */}
            <S.ImpactMetrics>
              <S.ImpactMetric>
                <div className="impact-metric-icon">
                  <S.FaHourglassHalfIcon />
                </div>
                <div className="impact-metric-label">Lentidão</div>
                <div className="impact-metric-value">
                  Resposta em horas/dias vs. minutos
                </div>
              </S.ImpactMetric>

              <S.ImpactMetric>
                <div className="impact-metric-icon">
                  <S.FaHandHoldingUsdIcon />
                </div>
                <div className="impact-metric-label">Oportunidades</div>
                <div className="impact-metric-value">
                  Negócios perdidos por demora
                </div>
              </S.ImpactMetric>

              <S.ImpactMetric>
                <div className="impact-metric-icon">
                  <S.FaUsersIcon />
                </div>
                <div className="impact-metric-label">Equipe</div>
                <div className="impact-metric-value">
                  Sobrecarga em tarefas manuais
                </div>
              </S.ImpactMetric>
            </S.ImpactMetrics>
          </S.ChallengeContainer>

          {/* Potencial de Transformação */}
          <S.PotentialBox>
            <S.PotentialHeader>
              <S.FaRocketIcon />
              <h3>O que podemos alcançar com automação?</h3>
            </S.PotentialHeader>

            <S.PotentialGrid>
              {/* Card 1: Eficiência */}
              <S.PotentialCard>
                <div className="potential-card-icon">
                  <S.FaTachometerAltIcon />
                </div>
                <div className="potential-card-label">Ganho de Eficiência</div>
                <div className="potential-card-value">80-95%</div>
                <p className="potential-card-description">
                  Redução no tempo de processos manuais através de automação
                  inteligente
                </p>
              </S.PotentialCard>

              {/* Card 2: Precisão */}
              <S.PotentialCard>
                <div className="potential-card-icon">
                  <S.FaBullseyeIcon />
                </div>
                <div className="potential-card-label">Precisão</div>
                <div className="potential-card-value">100%</div>
                <p className="potential-card-description">
                  Eliminação completa de erros humanos em processos automatizados
                </p>
              </S.PotentialCard>

              {/* Card 3: ROI */}
              <S.PotentialCard>
                <div className="potential-card-icon">
                  <S.FaChartLineIcon />
                </div>
                <div className="potential-card-label">Retorno do Investimento</div>
                <div className="potential-card-value">6-12</div>
                <p className="potential-card-description">
                  Meses para retorno completo do investimento em automação
                </p>
              </S.PotentialCard>
            </S.PotentialGrid>
          </S.PotentialBox>
        </S.Container>
      </S.Section>

      {/* Section 3: Soluções Propostas */}
      <S.Section id="solucoes" className="section-1">
        <S.Container>
          <S.SectionHeader>
            <S.SectionBadge>
              <S.FaLightbulbIcon />
              SEÇÃO 3
            </S.SectionBadge>

            <S.SectionTitle>
              <S.FaLightbulbIcon />
              Soluções de Automação VIDAL
            </S.SectionTitle>

            <S.SectionSubtitle>
              Automação inteligente e integração de sistemas para transformar seus
              processos
            </S.SectionSubtitle>
          </S.SectionHeader>

          {/* Introdução */}
          <S.ContentCard>
            <p>
              Apresentamos soluções personalizadas de automação que integram
              tecnologias modernas para resolver os desafios identificados, gerando
              eficiência, precisão e resultados mensuráveis.
            </p>
          </S.ContentCard>

          {/* Solução 1: Auto Checkout */}
          <S.SolutionContainer>
            <S.SolutionCard>
              <S.SolutionHeader>
                <S.SolutionIcon>
                  <S.FaLinkIcon />
                </S.SolutionIcon>
                <S.SolutionHeaderContent>
                  <S.SolutionBadge>AUTOMAÇÃO 1</S.SolutionBadge>
                  <S.SolutionTitle>
                    Integração Auto Checkout → ERP
                  </S.SolutionTitle>
                </S.SolutionHeaderContent>
              </S.SolutionHeader>

              <S.SolutionDescription>
                Desenvolvimento de middleware de integração entre o sistema de auto
                checkout e seu ERP, garantindo sincronização em tempo real de
                transações, estoque e dados financeiros.
              </S.SolutionDescription>

              {/* Funcionalidades */}
              <S.SolutionSectionTitle>
                <S.FaCheckCircleIcon />
                Funcionalidades
              </S.SolutionSectionTitle>
              <S.FunctionalitiesGrid>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Sincronização automática de vendas</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Atualização de estoque em tempo real</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Conciliação financeira automatizada</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Dashboard de monitoramento</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Alertas de inconsistências</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Relatórios automáticos</span>
                </S.FunctionalityItem>
              </S.FunctionalitiesGrid>

              {/* Tecnologias */}
              <S.SolutionSectionTitle>
                <S.FaCodeIcon />
                Tecnologias
              </S.SolutionSectionTitle>
              <S.TechBadges>
                <S.TechBadge>API RESTful</S.TechBadge>
                <S.TechBadge>Webhooks</S.TechBadge>
                <S.TechBadge>Banco de Dados em Nuvem</S.TechBadge>
                <S.TechBadge>Monitoramento 24/7</S.TechBadge>
              </S.TechBadges>

              {/* Benefícios */}
              <S.BenefitsBox>
                <S.SolutionSectionTitle style={{ marginBottom: '20px' }}>
                  <S.FaStarIcon />
                  Benefícios
                </S.SolutionSectionTitle>
                <S.BenefitsGrid>
                  <S.BenefitItem>
                    <S.BenefitIcon style={{ color: '#22c55e' }}>
                      <S.FaRocketIcon />
                    </S.BenefitIcon>
                    <S.BenefitContent>
                      <S.BenefitLabel>Redução de 95%</S.BenefitLabel>
                      <S.BenefitDescription>
                        No tempo de conciliação manual
                      </S.BenefitDescription>
                    </S.BenefitContent>
                  </S.BenefitItem>
                  <S.BenefitItem>
                    <S.BenefitIcon style={{ color: '#3b82f6' }}>
                      <S.FaChartBarIcon />
                    </S.BenefitIcon>
                    <S.BenefitContent>
                      <S.BenefitLabel>Dados Atualizados</S.BenefitLabel>
                      <S.BenefitDescription>
                        Informações sempre em tempo real
                      </S.BenefitDescription>
                    </S.BenefitContent>
                  </S.BenefitItem>
                  <S.BenefitItem>
                    <S.BenefitIcon style={{ color: '#8b5cf6' }}>
                      <S.FaBullseyeIcon />
                    </S.BenefitIcon>
                    <S.BenefitContent>
                      <S.BenefitLabel>Zero Erros</S.BenefitLabel>
                      <S.BenefitDescription>
                        Eliminação de erros de digitação
                      </S.BenefitDescription>
                    </S.BenefitContent>
                  </S.BenefitItem>
                  <S.BenefitItem>
                    <S.BenefitIcon style={{ color: '#f59e0b' }}>
                      <S.FaDollarSignIcon />
                    </S.BenefitIcon>
                    <S.BenefitContent>
                      <S.BenefitLabel>Economia</S.BenefitLabel>
                      <S.BenefitDescription>
                        Horas de trabalho manual economizadas
                      </S.BenefitDescription>
                    </S.BenefitContent>
                  </S.BenefitItem>
                </S.BenefitsGrid>
              </S.BenefitsBox>
            </S.SolutionCard>

            {/* Solução 2: RPA Seguradoras */}
            <S.SolutionCard>
              <S.SolutionHeader>
                <S.SolutionIcon className="blue">
                  <S.FaRobotIcon />
                </S.SolutionIcon>
                <S.SolutionHeaderContent>
                  <S.SolutionBadge className="blue">AUTOMAÇÃO 2</S.SolutionBadge>
                  <S.SolutionTitle>
                    RPA Inteligente para Seguradoras
                  </S.SolutionTitle>
                </S.SolutionHeaderContent>
              </S.SolutionHeader>

              <S.SolutionDescription>
                Sistema de automação robótica (RPA) com inteligência artificial que
                monitora demandas das seguradoras, consulta disponibilidade no ERP e
                aplica automaticamente para entrega de peças e veículos.
              </S.SolutionDescription>

              {/* Fluxo Automatizado */}
              <S.SolutionSectionTitle>
                <S.FaProjectDiagramIcon />
                Fluxo Automatizado
              </S.SolutionSectionTitle>
              <S.AutomationTimeline>
                <S.TimelineItem>
                  <S.TimelineNumber>1</S.TimelineNumber>
                  <S.TimelineContent>
                    <S.TimelineTitle>Monitoramento</S.TimelineTitle>
                    <S.TimelineDescription>
                      Bot acessa sistema da seguradora periodicamente
                    </S.TimelineDescription>
                  </S.TimelineContent>
                </S.TimelineItem>
                <S.TimelineItem>
                  <S.TimelineNumber>2</S.TimelineNumber>
                  <S.TimelineContent>
                    <S.TimelineTitle>Extração</S.TimelineTitle>
                    <S.TimelineDescription>
                      Identifica novas demandas de peças/veículos
                    </S.TimelineDescription>
                  </S.TimelineContent>
                </S.TimelineItem>
                <S.TimelineItem>
                  <S.TimelineNumber>3</S.TimelineNumber>
                  <S.TimelineContent>
                    <S.TimelineTitle>Consulta</S.TimelineTitle>
                    <S.TimelineDescription>
                      Verifica disponibilidade no ERP da Automec
                    </S.TimelineDescription>
                  </S.TimelineContent>
                </S.TimelineItem>
                <S.TimelineItem>
                  <S.TimelineNumber>4</S.TimelineNumber>
                  <S.TimelineContent>
                    <S.TimelineTitle>Análise</S.TimelineTitle>
                    <S.TimelineDescription>
                      IA avalia viabilidade e precificação
                    </S.TimelineDescription>
                  </S.TimelineContent>
                </S.TimelineItem>
                <S.TimelineItem>
                  <S.TimelineNumber>5</S.TimelineNumber>
                  <S.TimelineContent>
                    <S.TimelineTitle>Aplicação</S.TimelineTitle>
                    <S.TimelineDescription>
                      Submete proposta automaticamente
                    </S.TimelineDescription>
                  </S.TimelineContent>
                </S.TimelineItem>
                <S.TimelineItem>
                  <S.TimelineNumber>6</S.TimelineNumber>
                  <S.TimelineContent>
                    <S.TimelineTitle>Notificação</S.TimelineTitle>
                    <S.TimelineDescription>
                      Alerta equipe sobre aplicações realizadas
                    </S.TimelineDescription>
                  </S.TimelineContent>
                </S.TimelineItem>
              </S.AutomationTimeline>

              {/* Funcionalidades */}
              <S.SolutionSectionTitle>
                <S.FaCheckCircleIcon />
                Funcionalidades
              </S.SolutionSectionTitle>
              <S.FunctionalitiesGrid>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Monitoramento 24/7 do sistema de seguradoras</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Extração inteligente de dados (OCR + NLP)</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Integração com ERP para consulta de estoque</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Regras de negócio configuráveis</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Aplicação automática de propostas</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Dashboard de acompanhamento</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Relatórios de performance</span>
                </S.FunctionalityItem>
                <S.FunctionalityItem>
                  <S.FaCheckIcon />
                  <span>Histórico completo de operações</span>
                </S.FunctionalityItem>
              </S.FunctionalitiesGrid>

              {/* Tecnologias */}
              <S.SolutionSectionTitle>
                <S.FaCodeIcon />
                Tecnologias
              </S.SolutionSectionTitle>
              <S.TechBadges>
                <S.TechBadge>RPA (UiPath/Automation Anywhere)</S.TechBadge>
                <S.TechBadge>Python + IA</S.TechBadge>
                <S.TechBadge>OCR & NLP</S.TechBadge>
                <S.TechBadge>Integração ERP</S.TechBadge>
                <S.TechBadge>Cloud Computing</S.TechBadge>
              </S.TechBadges>

              {/* Benefícios */}
              <S.BenefitsBox>
                <S.SolutionSectionTitle style={{ marginBottom: '20px' }}>
                  <S.FaStarIcon />
                  Benefícios
                </S.SolutionSectionTitle>
                <S.BenefitsGrid>
                  <S.BenefitItem>
                    <S.BenefitIcon style={{ color: '#f59e0b' }}>
                      <S.FaBoltIcon />
                    </S.BenefitIcon>
                    <S.BenefitContent>
                      <S.BenefitLabel>Resposta Rápida</S.BenefitLabel>
                      <S.BenefitDescription>
                        Minutos vs. horas/dias
                      </S.BenefitDescription>
                    </S.BenefitContent>
                  </S.BenefitItem>
                  <S.BenefitItem>
                    <S.BenefitIcon style={{ color: '#22c55e' }}>
                      <S.FaBullseyeIcon />
                    </S.BenefitIcon>
                    <S.BenefitContent>
                      <S.BenefitLabel>100% Capturado</S.BenefitLabel>
                      <S.BenefitDescription>
                        Todas as oportunidades identificadas
                      </S.BenefitDescription>
                    </S.BenefitContent>
                  </S.BenefitItem>
                  <S.BenefitItem>
                    <S.BenefitIcon style={{ color: '#8b5cf6' }}>
                      <S.FaChartLineIcon />
                    </S.BenefitIcon>
                    <S.BenefitContent>
                      <S.BenefitLabel>Aumento de 40%+</S.BenefitLabel>
                      <S.BenefitDescription>
                        Em conversão de propostas
                      </S.BenefitDescription>
                    </S.BenefitContent>
                  </S.BenefitItem>
                  <S.BenefitItem>
                    <S.BenefitIcon style={{ color: '#3b82f6' }}>
                      <S.FaUsersIcon />
                    </S.BenefitIcon>
                    <S.BenefitContent>
                      <S.BenefitLabel>Equipe Estratégica</S.BenefitLabel>
                      <S.BenefitDescription>
                        Focada em atividades de alto valor
                      </S.BenefitDescription>
                    </S.BenefitContent>
                  </S.BenefitItem>
                </S.BenefitsGrid>
              </S.BenefitsBox>
            </S.SolutionCard>
          </S.SolutionContainer>
        </S.Container>

      </S.Section>

      {/* Section 4: Metodologia de Desenvolvimento */}
      <S.Section id="metodologia" className="section-4">
        <S.Container>
          <S.SectionHeader>
            <S.SectionBadge>
              <S.FaCogsIcon />
              SEÇÃO 4
            </S.SectionBadge>

            <S.SectionTitle>
              <S.FaCogsIcon />
              Nossa Metodologia
            </S.SectionTitle>

            <S.SectionSubtitle>
              Processo estruturado e ágil para garantir sucesso na implementação
            </S.SectionSubtitle>
          </S.SectionHeader>

          {/* Introdução */}
          <S.ContentCard>
            <p>
              Utilizamos uma metodologia ágil e consultiva, dividida em fases claras
              que garantem alinhamento constante com suas necessidades e expectativas.
            </p>
          </S.ContentCard>

          {/* Fases do Projeto */}
          <S.MethodologyPhases>
            {/* Fase 1 */}
            <S.PhaseCard className="blue">
              <div className="phase-header">
                <div className="phase-number">01</div>
                <div className="phase-icon-wrapper">
                  <div className="phase-title-group">
                    <S.FaSearchIcon className="phase-icon" />
                    <h3 className="phase-title">Descoberta e Análise</h3>
                  </div>
                  <p className="phase-objective">
                    Entendimento profundo dos sistemas e processos atuais
                  </p>
                </div>
                <div className="phase-duration">1-2 semanas</div>
              </div>
              <div className="phase-content">
                <div className="phase-section">
                  <h5><S.FaTasksIcon /> Atividades</h5>
                  <ul className="phase-list">
                    <li>Mapeamento completo dos sistemas existentes</li>
                    <li>Análise de APIs e integrações disponíveis</li>
                    <li>Levantamento de regras de negócio</li>
                    <li>Identificação de requisitos técnicos</li>
                    <li>Definição de KPIs de sucesso</li>
                  </ul>
                </div>
                <div className="phase-section">
                  <h5><S.FaBoxIcon /> Entregáveis</h5>
                  <ul className="phase-list">
                    <li>Documento de requisitos</li>
                    <li>Arquitetura proposta</li>
                    <li>Cronograma detalhado</li>
                  </ul>
                </div>
              </div>
            </S.PhaseCard>

            {/* Fase 2 */}
            <S.PhaseCard className="purple">
              <div className="phase-header">
                <div className="phase-number">02</div>
                <div className="phase-icon-wrapper">
                  <div className="phase-title-group">
                    <S.FaPencilRulerIcon className="phase-icon" />
                    <h3 className="phase-title">Design e Prototipação</h3>
                  </div>
                  <p className="phase-objective">
                    Criar solução técnica e validar com stakeholders
                  </p>
                </div>
                <div className="phase-duration">2-3 semanas</div>
              </div>
              <div className="phase-content">
                <div className="phase-section">
                  <h5><S.FaTasksIcon /> Atividades</h5>
                  <ul className="phase-list">
                    <li>Design da arquitetura de integração</li>
                    <li>Prototipação de interfaces (dashboards)</li>
                    <li>Definição de fluxos de automação</li>
                    <li>Modelagem de dados</li>
                    <li>Validação com equipe técnica</li>
                  </ul>
                </div>
                <div className="phase-section">
                  <h5><S.FaBoxIcon /> Entregáveis</h5>
                  <ul className="phase-list">
                    <li>Protótipos funcionais</li>
                    <li>Documentação técnica</li>
                    <li>Plano de testes</li>
                  </ul>
                </div>
              </div>
            </S.PhaseCard>

            {/* Fase 3 */}
            <S.PhaseCard className="green">
              <div className="phase-header">
                <div className="phase-number">03</div>
                <div className="phase-icon-wrapper">
                  <div className="phase-title-group">
                    <S.FaCodeIcon className="phase-icon" />
                    <h3 className="phase-title">Desenvolvimento</h3>
                  </div>
                  <p className="phase-objective">
                    Construir a solução com qualidade e segurança
                  </p>
                </div>
                <div className="phase-duration">4-8 semanas</div>
              </div>
              <div className="phase-content">
                <div className="phase-section">
                  <h5><S.FaTasksIcon /> Atividades</h5>
                  <ul className="phase-list">
                    <li>Desenvolvimento de APIs e integrações</li>
                    <li>Implementação de automações (RPA)</li>
                    <li>Desenvolvimento de dashboards</li>
                    <li>Testes unitários e de integração</li>
                    <li>Code review e boas práticas</li>
                  </ul>
                </div>
                <div className="phase-section">
                  <h5><S.FaBoxIcon /> Entregáveis</h5>
                  <ul className="phase-list">
                    <li>Código-fonte documentado</li>
                    <li>Ambiente de homologação</li>
                    <li>Documentação técnica completa</li>
                  </ul>
                </div>
              </div>
            </S.PhaseCard>

            {/* Fase 4 */}
            <S.PhaseCard className="orange">
              <div className="phase-header">
                <div className="phase-number">04</div>
                <div className="phase-icon-wrapper">
                  <div className="phase-title-group">
                    <S.FaVialIcon className="phase-icon" />
                    <h3 className="phase-title">Testes e Homologação</h3>
                  </div>
                  <p className="phase-objective">
                    Garantir qualidade e aderência aos requisitos
                  </p>
                </div>
                <div className="phase-duration">1-2 semanas</div>
              </div>
              <div className="phase-content">
                <div className="phase-section">
                  <h5><S.FaTasksIcon /> Atividades</h5>
                  <ul className="phase-list">
                    <li>Testes funcionais completos</li>
                    <li>Testes de carga e performance</li>
                    <li>Testes de segurança</li>
                    <li>Homologação com usuários-chave</li>
                    <li>Ajustes e refinamentos</li>
                  </ul>
                </div>
                <div className="phase-section">
                  <h5><S.FaBoxIcon /> Entregáveis</h5>
                  <ul className="phase-list">
                    <li>Relatório de testes</li>
                    <li>Sistema homologado</li>
                    <li>Documentação de usuário</li>
                  </ul>
                </div>
              </div>
            </S.PhaseCard>

            {/* Fase 5 */}
            <S.PhaseCard className="cyan">
              <div className="phase-header">
                <div className="phase-number">05</div>
                <div className="phase-icon-wrapper">
                  <div className="phase-title-group">
                    <S.FaRocketIcon className="phase-icon" />
                    <h3 className="phase-title">Implantação e Treinamento</h3>
                  </div>
                  <p className="phase-objective">
                    Colocar em produção com segurança e capacitar equipe
                  </p>
                </div>
                <div className="phase-duration">1 semana</div>
              </div>
              <div className="phase-content">
                <div className="phase-section">
                  <h5><S.FaTasksIcon /> Atividades</h5>
                  <ul className="phase-list">
                    <li>Deploy em ambiente de produção</li>
                    <li>Migração de dados (se necessário)</li>
                    <li>Treinamento da equipe</li>
                    <li>Documentação de operação</li>
                    <li>Suporte intensivo inicial</li>
                  </ul>
                </div>
                <div className="phase-section">
                  <h5><S.FaBoxIcon /> Entregáveis</h5>
                  <ul className="phase-list">
                    <li>Sistema em produção</li>
                    <li>Equipe treinada</li>
                    <li>Manuais de operação</li>
                  </ul>
                </div>
              </div>
            </S.PhaseCard>

            {/* Fase 6 */}
            <S.PhaseCard className="teal">
              <div className="phase-header">
                <div className="phase-number">06</div>
                <div className="phase-icon-wrapper">
                  <div className="phase-title-group">
                    <S.FaChartLineIcon className="phase-icon" />
                    <h3 className="phase-title">Monitoramento e Evolução</h3>
                  </div>
                  <p className="phase-objective">
                    Garantir performance e evoluir continuamente
                  </p>
                </div>
                <div className="phase-duration">Contínuo</div>
              </div>
              <div className="phase-content">
                <div className="phase-section">
                  <h5><S.FaTasksIcon /> Atividades</h5>
                  <ul className="phase-list">
                    <li>Monitoramento de performance</li>
                    <li>Análise de KPIs</li>
                    <li>Suporte técnico contínuo</li>
                    <li>Melhorias e otimizações</li>
                    <li>Novas funcionalidades</li>
                  </ul>
                </div>
                <div className="phase-section">
                  <h5><S.FaBoxIcon /> Entregáveis</h5>
                  <ul className="phase-list">
                    <li>Relatórios mensais</li>
                    <li>Melhorias contínuas</li>
                    <li>SLA de suporte</li>
                  </ul>
                </div>
              </div>
            </S.PhaseCard>
          </S.MethodologyPhases>

          {/* Diferenciais da Metodologia */}
          <S.MethodologyDifferentials>
            <h3>
              <S.FaStarIcon />
              Diferenciais da Nossa Metodologia
            </h3>
            <S.MethodDifferentialsGrid>
              <S.DifferentialItemMethod>
                <S.FaSyncAltIcon />
                <div>
                  <strong>Ágil e Flexível</strong>
                  <p>Adaptamos conforme necessidades evoluem</p>
                </div>
              </S.DifferentialItemMethod>
              <S.DifferentialItemMethod>
                <S.FaUsersIcon />
                <div>
                  <strong>Colaborativa</strong>
                  <p>Você participa ativamente de cada fase</p>
                </div>
              </S.DifferentialItemMethod>
              <S.DifferentialItemMethod>
                <S.FaChartBarIcon />
                <div>
                  <strong>Transparente</strong>
                  <p>Acompanhamento em tempo real do progresso</p>
                </div>
              </S.DifferentialItemMethod>
              <S.DifferentialItemMethod>
                <S.FaBullseyeIcon />
                <div>
                  <strong>Focada em Resultados</strong>
                  <p>KPIs claros desde o início</p>
                </div>
              </S.DifferentialItemMethod>
            </S.MethodDifferentialsGrid>
          </S.MethodologyDifferentials>
        </S.Container>
      </S.Section>

      {/* Section 5: Benefícios e Diferenciais */}
      <S.Section id="beneficios" className="section-5">
        <S.Container>
          <S.SectionHeader>
            <S.SectionBadge>
              <S.FaGiftIcon />
              SEÇÃO 5
            </S.SectionBadge>

            <S.SectionTitle>
              <S.FaGiftIcon />
              Benefícios da Automação VIDAL
            </S.SectionTitle>

            <S.SectionSubtitle>
              Transformação real com resultados mensuráveis
            </S.SectionSubtitle>
          </S.SectionHeader>

          {/* Benefícios Tangíveis */}
          <S.TangibleBenefits>
            {/* Card 1: Eficiência Operacional */}
            <S.BenefitCardLarge className="green">
              <S.BenefitCardIconLarge className="green">
                <S.FaTachometerAltIcon />
              </S.BenefitCardIconLarge>
              <S.BenefitCardMetric>80-95%</S.BenefitCardMetric>
              <S.BenefitCardDescription>
                Redução no tempo de processos manuais
              </S.BenefitCardDescription>
              <S.BenefitCardList>
                <li>Automação de tarefas repetitivas</li>
                <li>Eliminação de retrabalho</li>
                <li>Processos 24/7 sem intervenção</li>
              </S.BenefitCardList>
            </S.BenefitCardLarge>

            {/* Card 2: Redução de Custos */}
            <S.BenefitCardLarge className="blue">
              <S.BenefitCardIconLarge className="blue">
                <S.FaPiggyBankIcon />
              </S.BenefitCardIconLarge>
              <S.BenefitCardMetric>60-70%</S.BenefitCardMetric>
              <S.BenefitCardDescription>
                Economia em custos operacionais
              </S.BenefitCardDescription>
              <S.BenefitCardList>
                <li>Menos horas de trabalho manual</li>
                <li>Redução de erros custosos</li>
                <li>Otimização de recursos</li>
              </S.BenefitCardList>
            </S.BenefitCardLarge>

            {/* Card 3: Aumento de Receita */}
            <S.BenefitCardLarge className="purple">
              <S.BenefitCardIconLarge className="purple">
                <S.FaChartLineIcon />
              </S.BenefitCardIconLarge>
              <S.BenefitCardMetric>30-50%</S.BenefitCardMetric>
              <S.BenefitCardDescription>
                Crescimento em oportunidades capturadas
              </S.BenefitCardDescription>
              <S.BenefitCardList>
                <li>Resposta mais rápida ao mercado</li>
                <li>Mais negócios fechados</li>
                <li>Melhor experiência do cliente</li>
              </S.BenefitCardList>
            </S.BenefitCardLarge>
          </S.TangibleBenefits>

          {/* Benefícios Intangíveis */}
          <S.IntangibleBenefits>
            <h3>Benefícios Intangíveis</h3>
            <S.IntangibleGrid>
              <S.IntangibleItem>
                <S.FaBullseyeIcon />
                <div>
                  <strong>Foco Estratégico</strong>
                  <p>Equipe liberada para atividades de alto valor</p>
                </div>
              </S.IntangibleItem>
              <S.IntangibleItem>
                <S.FaChartBarIcon />
                <div>
                  <strong>Dados em Tempo Real</strong>
                  <p>Decisões baseadas em informações atualizadas</p>
                </div>
              </S.IntangibleItem>
              <S.IntangibleItem>
                <S.FaShieldAltIcon />
                <div>
                  <strong>Segurança</strong>
                  <p>Redução de riscos e compliance automatizado</p>
                </div>
              </S.IntangibleItem>
              <S.IntangibleItem>
                <S.FaExpandArrowsAltIcon />
                <div>
                  <strong>Escalabilidade</strong>
                  <p>Crescimento sem aumento proporcional de custos</p>
                </div>
              </S.IntangibleItem>
              <S.IntangibleItem>
                <S.FaLightbulbIcon />
                <div>
                  <strong>Inovação</strong>
                  <p>Cultura de transformação digital</p>
                </div>
              </S.IntangibleItem>
              <S.IntangibleItem>
                <S.FaSmileIcon />
                <div>
                  <strong>Satisfação</strong>
                  <p>Equipe mais motivada e clientes mais satisfeitos</p>
                </div>
              </S.IntangibleItem>
            </S.IntangibleGrid>
          </S.IntangibleBenefits>

          {/* Diferenciais VIDAL */}
          <S.VidalDifferentialsBox>
            <h3>
              <S.FaStarIcon />
              Por que a VIDAL é a escolha certa?
            </h3>
            <S.VidalDifferentialsGrid>
              <S.VidalDifferentialItem>
                <S.FaCheckCircleIcon />
                <div>
                  <strong>Experiência Comprovada</strong>
                  <p>Projetos de automação em diversos setores</p>
                </div>
              </S.VidalDifferentialItem>
              <S.VidalDifferentialItem>
                <S.FaCheckCircleIcon />
                <div>
                  <strong>Tecnologia de Ponta</strong>
                  <p>Ferramentas e frameworks mais modernos</p>
                </div>
              </S.VidalDifferentialItem>
              <S.VidalDifferentialItem>
                <S.FaCheckCircleIcon />
                <div>
                  <strong>Equipe Especializada</strong>
                  <p>Desenvolvedores, engenheiros de automação e consultores</p>
                </div>
              </S.VidalDifferentialItem>
              <S.VidalDifferentialItem>
                <S.FaCheckCircleIcon />
                <div>
                  <strong>Suporte Dedicado</strong>
                  <p>Acompanhamento contínuo pós-implementação</p>
                </div>
              </S.VidalDifferentialItem>
              <S.VidalDifferentialItem>
                <S.FaCheckCircleIcon />
                <div>
                  <strong>Segurança e Compliance</strong>
                  <p>Boas práticas de segurança da informação</p>
                </div>
              </S.VidalDifferentialItem>
              <S.VidalDifferentialItem>
                <S.FaCheckCircleIcon />
                <div>
                  <strong>ROI Garantido</strong>
                  <p>Foco em resultados mensuráveis desde o dia 1</p>
                </div>
              </S.VidalDifferentialItem>
            </S.VidalDifferentialsGrid>
          </S.VidalDifferentialsBox>
        </S.Container>
      </S.Section>

      {/* Section 6: Próximos Passos */}
      <S.Section className="section-6">
        <S.Container>
          <S.SectionHeader>
            <S.SectionBadge>
              <S.FaRocketIcon />
              JORNADA
            </S.SectionBadge>

            <S.SectionTitle>
              <S.FaRocketIcon />
              Do Zero à Automação
            </S.SectionTitle>

            <S.SectionSubtitle>
              Um processo simples e transparente para transformar sua empresa
            </S.SectionSubtitle>
          </S.SectionHeader>

          {/* Timeline de Jornada */}
          <S.JourneyTimeline>
            {/* Passo 1 */}
            <S.JourneyStep>
              <S.JourneyStepIcon>
                <S.FaHandshakeIcon />
              </S.JourneyStepIcon>
              <S.JourneyStepTitle>Reunião de Alinhamento</S.JourneyStepTitle>
              <S.JourneyStepDescription>
                Conversa inicial para entender em detalhes suas necessidades e expectativas
              </S.JourneyStepDescription>
              <S.JourneyStepDuration>1 hora</S.JourneyStepDuration>
            </S.JourneyStep>

            {/* Passo 2 */}
            <S.JourneyStep>
              <S.JourneyStepIcon>
                <S.FaClipboardCheckIcon />
              </S.JourneyStepIcon>
              <S.JourneyStepTitle>Análise Técnica</S.JourneyStepTitle>
              <S.JourneyStepDescription>
                Nossa equipe faz análise dos sistemas e processos atuais
              </S.JourneyStepDescription>
              <S.JourneyStepDuration>3-5 dias</S.JourneyStepDuration>
            </S.JourneyStep>

            {/* Passo 3 */}
            <S.JourneyStep>
              <S.JourneyStepIcon>
                <S.FaFileContractIcon />
              </S.JourneyStepIcon>
              <S.JourneyStepTitle>Proposta Detalhada</S.JourneyStepTitle>
              <S.JourneyStepDescription>
                Apresentação de escopo, cronograma e investimento
              </S.JourneyStepDescription>
              <S.JourneyStepDuration>2-3 dias</S.JourneyStepDuration>
            </S.JourneyStep>

            {/* Passo 4 */}
            <S.JourneyStep>
              <S.JourneyStepIcon>
                <S.FaRocketIcon />
              </S.JourneyStepIcon>
              <S.JourneyStepTitle>Kick-off do Projeto</S.JourneyStepTitle>
              <S.JourneyStepDescription>
                Início oficial do desenvolvimento
              </S.JourneyStepDescription>
              <S.JourneyStepDuration>Imediato</S.JourneyStepDuration>
            </S.JourneyStep>
          </S.JourneyTimeline>

          {/* Call to Action Box */}
          <S.CtaBox>
            <h3>Pronto para Transformar sua Operação?</h3>
            <p>
              Agende uma reunião sem compromisso para discutirmos como a automação pode revolucionar seus processos.
            </p>
            <S.CtaButtons>
              <S.BtnCtaPrimary href="https://wa.me/5515981198493" target="_blank">
                <S.FaCalendarCheckIcon />
                Agendar Reunião
              </S.BtnCtaPrimary>
              <S.BtnCtaSecondary href="https://wa.me/5515981198493" target="_blank">
                <S.FaCommentsIcon />
                Falar com Especialista
              </S.BtnCtaSecondary>
            </S.CtaButtons>
          </S.CtaBox>
        </S.Container>
      </S.Section>

      {/* Footer */}
      <S.Footer>
        <S.FooterContent>
          {/* Company Info */}
          <S.FooterColumn>
            <S.FooterBrand>
              <img
                src="https://i.ibb.co/RkZvggsr/logo.png"
                alt="VIDAL Inteligência Fiscal"
              />
            </S.FooterBrand>
            <p>
              Transformação digital através de automação inteligente e desenvolvimento de soluções personalizadas.
            </p>
            <S.FooterBadge>
              <div className="badge-header">
                <S.FaCheckCircleIcon />
                SOLUÇÕES PERSONALIZADAS
              </div>
              <p>Automação • Desenvolvimento • IA • Transformação comprovada</p>
            </S.FooterBadge>
          </S.FooterColumn>

          {/* Contact Info */}
          <S.FooterColumn>
            <S.FooterTitle>Informações de Contato</S.FooterTitle>
            <S.FooterContactInfo>
              <S.FooterContactItem>
                <strong>E-mail:</strong>
                <span>fabricio@fhsouza.com.br</span>
              </S.FooterContactItem>
              <S.FooterContactItem>
                <strong>Telefone:</strong>
                <span>15 981198493</span>
              </S.FooterContactItem>
              <S.FooterContactItem>
                <strong>Website:</strong>
                <a href="https://lp.vidal-app.com">lp.vidal-app.com</a>
              </S.FooterContactItem>
            </S.FooterContactInfo>
          </S.FooterColumn>
        </S.FooterContent>

        <S.FooterBottom>
          <S.FooterCopyright>
            <p>&copy; 2024 VIDAL. Todos os direitos reservados.</p>
            <span>Proposta Comercial • Automação Automec</span>
          </S.FooterCopyright>

          <S.FooterLegal>
            <a href="#">Privacidade</a>
            <a href="#">Termos</a>
            <a href="https://lp.vidal-app.com" target="_blank" rel="noopener noreferrer">Website</a>
          </S.FooterLegal>
        </S.FooterBottom>
      </S.Footer>

    </S.PageWrapper>
  );
}
